export default function () {
    function buildReactiveHead(details, error) {
        watch(
            details,
            () => {
                buildHead(details.value, error.value);
            },
            {immediate: true},
        );
    }

    function buildHead(details, error) {
        if (details === null && !error) return useSeo().buildHeadLoading();
        if (!details) return useSeo().buildHeadNotFound();
        return useSeo().buildHead({
            title: details.name + ' | West Coast Swing Class',
            description: details.address,
            index: true,
        });
    }

    return {buildReactiveHead};
}
